export default __webpack_public_path__ + "static/char-s-52-en-23d49f6e9a0c6a20892be0c61f6389c7.png";